let hasConsole;
function onLineLog(data) {
    // Output to browser console
    if (this.logToConsole) {
        hasConsole = hasConsole || typeof console !== 'undefined';
        if (hasConsole)
            try {
                // use Function.prototype.apply since IE's console functions are not real functions
                Function.prototype.apply.call(console[data.level] || console.log, console, data.arguments);
            }
            catch (e) {
                // Swalow console errors
            }
    }
}
function applyPluginOnto(obj, logToConsole) {
    return Object.assign(obj, {
        pluginName: 'loggerTargetConsole',
        dependencies: ['logger'],
        rootInit: function ConsoleLogTarget() {
            this.logToConsole = logToConsole;
            this.signals.onLineLog.add(onLineLog, this);
        },
    });
}
export default function LoggerTargetConsolePlugin(config) {
    const logToConsole = config === true || !!(config && config.logToConsole);
    return applyPluginOnto({}, logToConsole);
}
// Put a default plugin definition on the plugin function
applyPluginOnto(LoggerTargetConsolePlugin, true);
//# sourceMappingURL=logger_target_console.js.map